import React, { useContext } from "react";
import { TableHead } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { DateTimeFmt } from "../../../utils/DataUtils";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Context from "../../../context/Context";
import language from '../../../nls/language.json';

function PartFlow({ sagA_PartFlow }) {
  const {
    selectedCountry,
  } = useContext(Context);

  var style = {
    padding: 0.6,
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ overflow: "auto" }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.codigo}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.operacao}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.setor}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.chaveModelo}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.status}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.dataHora}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.fluxo.tableHeader.responsavel}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!sagA_PartFlow &&
            sagA_PartFlow.map((eachObj, index) => (
              <TableRow
                key={`partFlow-${index}`}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  padding: "0px",
                }}
              >
                <TableCell component="th" scope="row" sx={style}>
                  {eachObj.roteiro_Operacao}
                </TableCell>
                <TableCell sx={style}>
                  {eachObj.roteiro_OperacaoTexto}
                </TableCell>
                <TableCell sx={style}>
                  {eachObj.roteiro_CentroTrabalho}
                </TableCell>
                <TableCell sx={style}>{eachObj.roteiro_ChaveModelo}</TableCell>
                <TableCell sx={style}>{eachObj.tipo_Notificacao} </TableCell>
                <TableCell sx={style}>
                  {DateTimeFmt(eachObj.dt_Hr_Apont)}
                </TableCell>
                <TableCell sx={style}>{eachObj.operador}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PartFlow;
